import React from 'react'
import Ink from 'react-ink';
import { connect } from 'react-redux'
import { printTest, generateZReport, generateXReport, printHistoryXZ, printArticleReport, openDrawer, scaleTest, printObjectReport } from '../actions/receiptActions'
import { dummyCheckLicense, setConfirmModal, setMessageModal } from '../actions/generalActions'
import { setFunctionBarType } from '../actions/layoutActions'
import * as types from '../constants/General'
import * as resource from '../constants/Resources'
import { processFunction } from '../actions/keyFunctionActions'
import * as functions from '../constants/Functions'
import { getPos, getTranslation } from '../actions/dataActions'
import { hasRight } from '../actions/rightsActions'
import * as right from '../constants/Rights'
import PropTypes from 'prop-types'

class FunctionButton extends React.Component {
  constructor(props) {
    super(props);
    this.handleTouchTap = this.handleTouchTap.bind(this);
    this.exitToWindows = this.exitToWindows.bind(this);
  }

  exitToWindows() {
    window.open('', '_self').close();
  }

  handleTouchTap() {
    this.props.setFunctionBarType(types.FUNCTIONBAR_NONE);
    switch (this.props.type) {
      case types.FUNCTIONBAR_STATUS_PRINTER:
        this.props.printTest(this.props.itemid);
        break;
      case types.FUNCTIONBAR_STATUS_DRAWER:
        if (this.props.hasRight(right.POS_DRAWER, false)) {
          this.props.openDrawer(true)
        }
        break;
      case types.FUNCTIONBAR_STATUS_SCALE:
        this.props.scaleTest(this.props.itemid);
        break;
      case types.FUNCTIONBAR_FUNCTION_ZREPORT:
        if (this.props.hasRight(right.POS_ZREPORT, true)) {
          this.props.setConfirmModal(this.props.getTranslation(resource.MODAL_RESET_CASHREGISTER), this.props.generateZReport, null);
        }
        break;
      case types.FUNCTIONBAR_FUNCTION_XREPORT:
        if (this.props.hasRight(right.POS_XREPORT, true)) {
          this.props.generateXReport(this.props.itemid === 3, false);
        }
        break;
      case types.FUNCTIONBAR_FUNCTION_XINFOREPORT:
        if (this.props.hasRight(right.POS_XREPORT, true)) {
          this.props.generateXReport(false, true);
        }
        break;
      case types.FUNCTIONBAR_FUNCTION_OBJECTREPORT:
        this.props.printObjectReport();
        break;
      case types.FUNCTIONBAR_FUNCTION_HISTORIE:
        if (this.props.hasRight(right.POS_ZREPORT, true)) {
          this.props.printHistoryXZ();
        }
        break;
      case types.FUNCTIONBAR_FUNCTION_ARTICLEREPORT:
        if (this.props.hasRight(right.POS_ZREPORT, true)) {
          this.props.printArticleReport();
        }
        break;
      case types.FUNCTIONBAR_FUNCTION_LICENSE:
        const pos = this.props.getPos(this.props.posid);
        let msg = `${this.props.getTranslation(resource.DEVICE_ID)}: ${this.props.uniqueid}`;
        if (pos !== null) {
          msg = `${msg}\n${this.props.getTranslation(resource.SERIALNUMBER)}: ${pos.SerialNumber}`;
        }
        this.props.setMessageModal(true, msg);
        this.props.dummyCheckLicense();
        break;
      case types.FUNCTIONBAR_FUNCTION_EXITTOWINDOWS:
        this.props.setConfirmModal(this.props.getTranslation(resource.MODAL_CLOSE_CASHREGISTER), this.exitToWindows, null);
        break;
      case types.FUNCTIONBAR_FUNCTION_WORKIN:
        this.props.processFunction(functions.WorkIn);
        break;
      case types.FUNCTIONBAR_FUNCTION_WORKOUT:
        this.props.processFunction(functions.WorkOut);
        break;
      default:
        break;
    }
  }

  render() {
    let isDisabled = this.props.type === types.FUNCTIONBAR_NONE;
    let icon = ''
    let warning = false;
    if (this.props.status > 100) {
      icon = 'warning sign icon';
      warning = true;
    }
    
    return (
      <button
        onClick={isDisabled ? undefined : this.handleTouchTap}
        className={`functionbutton${warning ? ' warning' : ''}${isDisabled ? ' functionbutton-disabled' : ''}`}
        style={!isDisabled ? { background: this.props.color } : undefined}
        disabled={isDisabled}
      >
        {this.props.text}&nbsp;
        {icon && <i className={icon}>&nbsp;</i>}
        <Ink />
      </button>
    );
  }
}

FunctionButton.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  type: PropTypes.number,
  itemid: PropTypes.number,
  itemparam: PropTypes.string,
  status: PropTypes.number,
  statusmessage: PropTypes.string,
  uniqueid: PropTypes.string,
  posid: PropTypes.number,
  printTest: PropTypes.func,
  generateZReport: PropTypes.func,
  generateXReport: PropTypes.func,
  dummyCheckLicense: PropTypes.func,
  setConfirmModal: PropTypes.func,
  setMessageModal: PropTypes.func,
  setFunctionBarType: PropTypes.func,
  printObjectReport: PropTypes.func,
  processFunction: PropTypes.func,
  getPos: PropTypes.func,
  openDrawer: PropTypes.func,
  getTranslation: PropTypes.func,
  hasRight: PropTypes.func,
  scaleTest: PropTypes.func,
  printHistoryXZ: PropTypes.func,
  printArticleReport: PropTypes.func,
};


function mapStateToProps(state) {
  return {
    uniqueid: state.generalState.uniqueid,
    posid: state.generalState.posId
  }
}

export default connect(mapStateToProps, {
  printTest,
  generateZReport,
  generateXReport,
  dummyCheckLicense,
  setConfirmModal,
  setFunctionBarType,
  setMessageModal,
  processFunction,
  getPos,
  openDrawer,
  getTranslation,
  hasRight,
  scaleTest,
  printHistoryXZ,
  printArticleReport,
  printObjectReport
})(FunctionButton)



// WEBPACK FOOTER //
// src/components/FunctionButton.jsx